"use strict";

exports.__esModule = true;
exports.Box = Box;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["component", "style", "x", "y", "width", "height", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A simple box which can be drawn at an arbitrary position.
 */
function Box(_ref) {
  var _ref$component = _ref.component,
    Component = _ref$component === void 0 ? "div" : _ref$component,
    style = _ref.style,
    x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height,
    children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    style: Object.assign({
      position: "absolute"
    }, style, {
      top: y,
      left: x,
      width: width,
      height: height
    })
  }, extra), typeof children === "function" ? children({
    width: width,
    height: height
  }) : children);
}